import { FeatureKey, IFeaturesSettings } from '@core/types'

export function isFeatureEnabled(featureKey: FeatureKey, features: IFeaturesSettings | undefined): boolean {
	return features?.[featureKey] ?? true
}
